import dayjs from 'dayjs';
import { Integration, IntegrationType, NonWorkingDay } from '../graphql/types';

export function getNextBusinessDay(start: Date, nonWorkingDays: NonWorkingDay[] = []): Date {
  let minDate = dayjs(start);
  while ([6, 0].includes(minDate.day()) || nonWorkingDays.some((d) => dayjs(d.date).isSame(minDate, 'date'))) {
    minDate = minDate.add(1, 'day');
  }
  return minDate.toDate();
}

export function getProcessorStartDate(
  integration?: Integration | null,
  integrationType?: IntegrationType | null,
  currentStartDate?: Date,
  nonWorkingDays: NonWorkingDay[] = [],
  startDateChanged: boolean = false
): Date {
  const resolvedIntegrationType = integrationType || (integration?.type as IntegrationType | undefined) || IntegrationType.DevNull;
  const today = dayjs().set('hour', 0).set('minute', 0).set('second', 0).toDate();
  const tomorrow = dayjs().set('hour', 0).set('minute', 0).set('second', 0).add(1, 'day').toDate();
  const nextBusinessDay = getNextBusinessDay(tomorrow, nonWorkingDays);

  if (
    ![IntegrationType.GoAch, IntegrationType.GoAchBot, IntegrationType.DevNull].includes(resolvedIntegrationType) &&
    currentStartDate &&
    dayjs(currentStartDate).isBefore(nextBusinessDay)
  ) {
    return nextBusinessDay;
  }

  if (!startDateChanged) {
    return [IntegrationType.GoAch, IntegrationType.GoAchBot, IntegrationType.DevNull].includes(resolvedIntegrationType)
      ? getNextBusinessDay(today, nonWorkingDays)
      : nextBusinessDay;
  }

  return currentStartDate || nextBusinessDay;
}
